export class UsersSegmentsOperationsRequest {
	public userIds: number[];
	public segmentsOperations: { segmentId?: number, operationIds?: number[] }[];
}
